<div class="sticky-total-price-footer">
  <div class="sticky-total-price-footer__total-price" [class.sticky-total-price-footer__total-price--calculating]="!priceAvailable()">
    @if (priceAvailable()) {
    <div class="sticky-total-price-footer__total-price__label-container">
      <div class="sticky-total-price-footer__total-price__label" i18n>Total price</div>
    </div>
    <div class="sticky-total-price-footer__total-price__price">
      <span class="sticky-total-price-footer__total-price__amount"> {{ grandTotal() | lxPrice : { currency: currency(), showCurrency: false } }} </span
      ><span class="sticky-total-price-footer__total-price__currency">{{ currency() }}</span>
    </div>
    } @else {
    <div class="sticky-total-price-footer__total-price__calculating-message" i18n>Calculating price...</div>
    }
  </div>
  <div class="sticky-total-price-footer__button-container">
    <lx-button
      i18n-text
      text="Book now"
      [block]="true"
      [buttonStyle]="'primary'"
      [disabled]="!formValid()"
      [lxGAClickEvent]="bookNowEventName()"
      data-qa="book-now-button"
      (buttonClick)="onBookNow.emit()"
    >
    </lx-button>
  </div>
</div>
